export default __webpack_public_path__ + "static/media/158d4dba38c3243c7b4bb9de476a91371581620211080.3c8ff8fd.webp";